import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getnotification, deletenotifications, deleteallnotifications } from '../../ReduxToolkit/Slice/Notification/Notification';
import CommanTable from '../../components/Table/CommanTable';

function Notification() {
    const dispatch = useDispatch();
    const { status, notifications } = useSelector((state) => state.notification || { status: 'idle', notification: { data: [] } });

    // const reversedData = [...notifications.data.data].reverse();
    //  get
    useEffect(() => {
        if (status === "idle") {
            dispatch(getnotification())
        }
    }, [dispatch, status]);
    // delete api
    const handleDelete = (notificationid) => {
        const Isconfirmed = window.confirm("Are you sure! you want delete this notification")
        if (Isconfirmed) {
            dispatch(deletenotifications(notificationid))
        };
    }
    //   all delete 
    const alldetete = () => {
        const Isconfirmed = window.confirm("Are you sure! you want delete all notification")
        if (Isconfirmed) {
            dispatch(deleteallnotifications())
        };
    }
    function formatDate(dateString) {
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
      }
    const columns = [
        { label: "Message", accessor: "message" },
        { label: "Date", accessor: "createdAt", formatter: formatDate },

    ];

    return (
        <>
            <div>
                <div className='d-flex justify-content-between my-3'>
                    <h3>Notification Forms</h3>
                </div>
                <CommanTable
                    columns={columns}
                    data={notifications.data || []}
                    status={status}
                    onDelete={handleDelete}
                />
            </div>
        </>
    );
}

export default Notification;
